import React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import styled from 'styled-components';
const ButtonWapper = styled.div `
  font-family: Poppins;
  display: flex;
  padding: 6px 12px;
  align-items: center;
  max-width: 91px;
  background: #f1f4f7;
  color: #4b4f5e;
  border: none;
  cursor: pointer;
  font-weight: 400;
  line-height: 24px;
  font-size: 16px;
  border-radius: 4px;
  gap: 8px;
  cursor: ${({ disableActive }) => (disableActive ? 'not-allowed' : 'pointer')};
`;
const InfoPerpageWapper = styled.div `
  display: flex;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  color: #4b4f5e;
  gap: 24px;
  margin: 0 13rem;
`;
export const PaginationBumpItems = ({ totalItems, itemsPerPage, currentPage, onPageChange, }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };
    return (React.createElement(React.Fragment, null,
        totalPages > 1 && (React.createElement(ButtonWapper, { onClick: handlePreviousPage, disableActive: currentPage === 1, className: 'm-l-5' },
            React.createElement(FaArrowLeft, null),
            React.createElement("span", null, "Prev"))),
        React.createElement(InfoPerpageWapper, null,
            React.createElement("span", null,
                totalItems,
                " Orders"),
            React.createElement("span", null,
                currentPage,
                " / ",
                totalPages,
                " Pages")),
        totalPages > 1 && (React.createElement(ButtonWapper, { onClick: handleNextPage, disableActive: currentPage === totalPages, className: 'm-r-5' },
            React.createElement("span", null, "Next"),
            React.createElement(FaArrowRight, null)))));
};
//# sourceMappingURL=pagination-bump-items.js.map